




import React, { useContext, useEffect, useState } from "react";



import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";



function ChangeNameCompany () {
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",
      }));
    }
  }, []);

  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };

  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_city: '' })

  const [errors, setErrors] = useState({});

  const { services, loading, error } = useContext(ServicesContext);
  // if (loading) {
  //   return <div>Loading...</div>;  // Show loading state while fetching data
  // }

  // if (error) {
  //    return <div>{error}</div> // Show error state if there was an issue fetching data
  // }
  const service = Array.isArray(services) ? services.find(s => s.service_id === 48) : null;

  const validateForm = () => {
    const newErrors = {};

    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }


    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };




  const formPutPartenshipdeed = async (e) => {
    e.preventDefault();

    // ✅ Check if user is logged in
    // if (!token) {
    //   alert("Please log in to continue.");
    //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
    //   navigate('/login'); // 👈 Use this if you're using React Router
    //   return;
    // }
    if (!validateForm()) return;

     localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });

  };



const faqList = [
  {
    question: "Why would a company consider a name change?",
    answer: "A company may consider a name change due to rebranding, mergers, acquisitions, or to better align with its evolving vision and goals."
  },
  {
    question: "What legal steps are involved in changing a company's name?",
    answer: "The legal steps typically include filing articles of amendment with the relevant government authorities and updating business licenses and registrations."
  },
  {
    question: "How long does the name change process usually take?",
    answer: "The time frame varies by jurisdiction but can take several weeks to a few months, depending on government processing times."
  },
  {
    question: "Will the name change affect contracts and agreements with clients and suppliers?",
    answer: "The name change may require updating existing contracts and agreements to reflect the new company name."
  },
  {
    question: "How will the name change impact the company's branding and marketing efforts?",
    answer: "A name change may necessitate rebranding efforts, such as updating logos, websites, and marketing materials."
  },
  {
    question: "Can a name change result in any negative consequences?",
    answer: "While a well-executed name change can be positive, it's crucial to consider potential customer confusion and market perception."
  },
  {
    question: "What communication strategies should the company adopt during the name change?",
    answer: "Transparent and consistent communication with employees, customers, suppliers, and investors is vital to minimize disruption."
  },
  {
    question: "Are there any trademark or intellectual property considerations for a name change?",
    answer: "A company must ensure the new name doesn't infringe on existing trademarks or intellectual property rights."
  },
  {
    question: "What benefits can the company expect after the name change?",
    answer: "The benefits include improved brand identity, increased market opportunities, customer engagement, and a competitive advantage in the industry."
  },
  {
    question: "What happens if the application for a name change is rejected?",
    answer: "If the application is rejected, the company must identify the reason for rejection and rectify the issues before reapplying."
  }
];










  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2 ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>

                <h1 className="sk-text-color">Change in Name of Company</h1>

                <p className="pdrl-text">Get Change in Name (Company) for only <span className="text-color">Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                <p className="pd-text">Unlock your business's true potential with DM2Legal's expert "Change In Name Company" service. A successful name change can enhance the company's image and credibility, reflecting its readiness to evolve and embrace change.
                </p>

                <div className="banner">
                  <img src="assets/icons/banner.svg" alt="" srcset="" />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now</h3>         <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Final Price, No Hidden Costs)</span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Contact Number<span className="red">*</span></label>{errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3 btn-color" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">


            <div className="col-lg-12">

              {/* <h2>Annual Compliance LLP </h2> */}


              <p className="pd-text"> 

Discover the transformative potential of a name change with DM2Legal’s premier "Change In Name Company" service. Your company’s path to reinvention starts here, with expert guidance at every crucial step. Our experienced team specializes in navigating the complexities of rebranding, mergers, and acquisitions, ensuring a seamless legal process from start to finish.

A new name symbolizes a fresh identity and unlocks exciting opportunities. We’re dedicated to making your transition smooth and successful, while thoughtfully managing stakeholder perceptions. Together, we’ll craft a compelling story that highlights your business’s growth, strengthens your market presence, and elevates your brand image.

Trust DM2Legal to empower your company’s adaptability and pave the way for a vibrant future in today’s dynamic business environment. Let us partner with you to unlock your business’s full potential through the power of a strategic name change.

              </p>
            </div>

          </div>


        </div>
      </div>



      <div className="service-binifits9 bg-white" >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">How to apply</h2>
                <div className="space20"></div>
                <img src="assets/new/Change-In-Name-Company.png" />
              </div>
              <div className="space20"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="space20 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate text-center">Benefits </h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
         <div className="row">
  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon1.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Enhanced Brand Identity</a></h4>
        <p className="font-f-7">A new name can rejuvenate the brand and create a stronger market presence.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon2.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Expanded Market Opportunities</a></h4>
        <p className="font-f-7">A fresh name can attract new customers and open doors to different markets.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon3.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Increased Customer Engagement</a></h4>
        <p className="font-f-7">Rebranding can spark interest and excitement among existing customers.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon4.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Competitive Advantage</a></h4>
        <p className="font-f-7">A name change can set the company apart from competitors and showcase innovation.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon5.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Improved Reputation</a></h4>
        <p className="font-f-7">A successful name change can enhance the company's image and credibility.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon6.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Adaptability and Growth</a></h4>
        <p className="font-f-7">A new name reflects the company's readiness to evolve and embrace change.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon7.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Legal Clarity</a></h4>
        <p className="font-f-7">Updating the company name ensures compliance with legal documentation and public records.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon8.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Clearer Market Positioning</a></h4>
        <p className="font-f-7">A new name can help clearly define the company's niche and value proposition in the market.</p>
      </div>
    </div>
  </div>
</div>






          <div className="space20"></div>
        </div>
      </div>

      <div className="service-binifits9 sp0" id="service2">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="hadding7">
                <div className="space80"></div>
                <h2>Online Registration Procedure </h2>
              </div>
              <div className="partnership-deade-section">
                <div className="space40"></div>

                <ul className="disc-list">
                  <li>
                    <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Our team will analyze your submitted documents, looking for any misleading or incorrect information.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Our professionals are here to help you with document requirements and licensing necessities.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Discuss with our professionals the reasons and desired name options during consultation.

                    </span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>We'll update you once our team completes preparing the supporting documents and other formalities.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                    <span>Obtain approvals and complete the process smoothly with Dm2Legal's expert guidance, hassle-free, and compliant with regulations.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                </ul>

                <div className="space80"></div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="bg-white">

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                    <div className="space30"></div>
                    <div id="general">


                      {faqList.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate">Why Choose Us?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                  <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                  <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                  <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                  <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                  <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                  <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      < WhatsAppScrollButton />

      <Footer />
      <CircularScrollProgress />
    </div>

  );
}
export default ChangeNameCompany ;

